module.exports = __webpack_public_path__ + "static/media/cover.afca75ee.png";